import React, { useState, useEffect, useContext } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { img_2000, unavailable } from "../../config/config";

// import Swiper core and required modules
import SwiperCore, { Navigation } from "swiper";
import TvDesc from "./TvDesc";
import { MovieIndexContext } from "../../context/MovieIndexContext";
import "./TvPosterSlider.scss";

SwiperCore.use([Navigation]);

const TvPosterSlider = ({ content, movieId }) => {
  const [swiper, setSwiper] = useState(null);
  // eslint-disable-next-line
  const { movieIndex } = useContext(MovieIndexContext);
  const slideTo = (index) => swiper.slideTo(index);
  useEffect(() => {
    if (swiper) {
      slideTo(movieIndex);
      // console.log("workingggggggggg");
    } // eslint-disable-next-line
  }, [movieIndex, swiper]);
  return (
    <>
      <Swiper
        navigation={true}
        className="mySwiper"
        onSlideChange={movieId}
        onSwiper={setSwiper}
      >
        {React.Children.toArray(
          content?.map((item) => {
            return (
              <SwiperSlide style={{ backgroundColor: "black" }}>
                <img
                  className="tv-poster"
                  src={
                    item.poster_path
                      ? `${img_2000}/${item.poster_path}`
                      : unavailable
                  }
                  alt="TV-poster"
                />
                <TvDesc
                  title={item.title || item.name}
                  genre={item.genres_name}
                />
              </SwiperSlide>
            );
          })
        )}
      </Swiper>
    </>
  );
};

export default TvPosterSlider;
